var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFb = function SvgSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.115 0H2.885A2.885 2.885 0 0 0 0 2.885v34.23A2.885 2.885 0 0 0 2.885 40h18.482V24.531h-5.195v-6.054h5.195V14.02c0-5.168 3.155-7.98 7.764-7.98 2.208 0 4.105.164 4.658.238v5.4h-3.178c-2.508 0-2.994 1.192-2.994 2.941v3.857h5.996l-.781 6.054h-5.215V40h9.498A2.885 2.885 0 0 0 40 37.115V2.885A2.885 2.885 0 0 0 37.115 0Z"
  })));
};
export default SvgSocialFb;